import React, { Component } from "react";
import ButtonAlt from "../../ButtonAlt/ButtonAlt";
import "./ProdCard.css";

class ProdCard extends Component {
	render() {
		let prodInfo = this.props.info;
		return (
			<div
				className={prodInfo.selected ? "prod-card selected-card" : "prod-card"}
			>
				<div className="prod-label">
					<p className="prod-header">{prodInfo.name}</p>
					<p className="prod-price">${prodInfo.price}/mo.</p>
				</div>
				<div className="prod-content">
					<img src={prodInfo.icon} alt={`${prodInfo.name}-icon`} />
					<p className="prod-desc">{prodInfo.desc}</p>
					<ButtonAlt
						selected={prodInfo.selected ? true : false}
						label={prodInfo.selected ? "Added to plan" : "Add to plan"}
						onClick={() => this.props.addToOnboardingCart(prodInfo.name)}
					/>
				</div>
			</div>
		);
	}
}

export default ProdCard;


// WEBPACK FOOTER //
// ./src/components/SignUp/ProdCard/ProdCard.js